// @ts-ignore
import RecordRTC from 'recordrtc';
import { RecordType } from '../types';

export class MediaRecorderManager {
  private recorder: any= null;
  private stream: MediaStream | null = null;

  async startRecording(
    type: RecordType,
    onDataAvailable?: (blob: Blob) => void
  ): Promise<MediaStream> {
    try {
      // Lấy media stream
      const constraints = type === 'video' 
        ? { video: true, audio: true }
        : { audio: true };

      this.stream = await navigator.mediaDevices.getUserMedia(constraints);

      // Cấu hình RecordRTC
      const options: any = {
        type: type === 'video' ? 'video' : 'audio',
        mimeType: type === 'video' 
          ? 'video/webm;codecs=vp8,opus' 
          : 'audio/webm',
        recorderType: type === 'video' 
          ? RecordRTC.MediaStreamRecorder 
          : RecordRTC.StereoAudioRecorder,
        numberOfAudioChannels: 1,
        desiredSampRate: 16000,
      };

      this.recorder = new RecordRTC(this.stream, options);
      this.recorder.startRecording();

      return this.stream;
    } catch (error) {
      console.error('Error starting recording:', error);
      throw error;
    }
  }

  pauseRecording(): void {
    if (this.recorder) {
      this.recorder.pauseRecording();
    }
  }

  resumeRecording(): void {
    if (this.recorder) {
      this.recorder.resumeRecording();
    }
  }

  async stopRecording(): Promise<Blob | null> {
    return new Promise((resolve) => {
      if (!this.recorder) {
        resolve(null);
        return;
      }

      this.recorder.stopRecording(() => {
        const blob = this.recorder?.getBlob();
        this.cleanup();
        resolve(blob || null);
      });
    });
  }

  cleanup(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
    if (this.recorder) {
      this.recorder.destroy();
      this.recorder = null;
    }
  }

  getState(): string {
    return this.recorder?.getState() || 'inactive';
  }
}

export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const createMediaElement = (blob: Blob, type: RecordType): string => {
  const url = URL.createObjectURL(blob);
  if (type === 'video') {
    return `<video controls src="${url}" style="max-width: 100%;"></video>`;
  } else {
    return `<audio controls src="${url}"></audio>`;
  }
};

